import Styled from "styled-components";
import { useContext } from "react";
import { SignOutUser } from "../../Firebase";
import { useNavigate } from "react-router-dom";
import { CurrentUserContext } from "../../Contexts/CurrentUserContext";
import { DialogWindowContext } from "../../Contexts/DialogueWindowContext";
import UserEdit from "./UserEdit/UserEdit";
import { IonIcon } from "@ionic/react";
import {
  link,
  flash,
  logOut,
  call,
  person,
  earth,
  warning,
  people,
  download,
  flame,
  documents,
  alertCircle,
} from "ionicons/icons";

const SettingOptions = Styled.div`
    display: flex;
    gap: 10px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    padding: 15px 10px;

    h1{
      color: var(--accent-color-dark);
      width: 100%;
      font-size: 25px;
      font-weight: 500;
    }
    @media (max-width: 400px) {
    h1{
      font-size: 20px;
    }
  }
`;

const Section = Styled.div`
width: 97%;
margin-top: 10px;
`;

const SectionTitle = Styled.div`
  border-bottom: 1px solid var(--accent-color-dark);
  padding-bottom: 5px;

  h2{
    font-size: 15px;
    font-weight: 500;
    margin-left: 10px;
  }
`;

const ButtonsWrapper = Styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 10px;
  width: 100%;
  margin-top: 10px;
`;

const LinkChip = Styled.button`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid white;
  border-radius: 16px;
  background-color: white;
  padding: 2px 10px;
  cursor: pointer;
  width: fit-content;

  ion-icon {
  font-size: 19px;
}

  h4{
    font-size: 15px;
    margin-left: 4px;
  }
`;

function Settings() {
  const navigate = useNavigate();
  const DialogWindow = useContext(DialogWindowContext);
  const userContext = useContext(CurrentUserContext);
  const user = userContext?.currentUser;

  const showEditWindowHandler = () => {
    if (!user) return;
    DialogWindow.setDialogProps((prevProps) => ({
      ...prevProps,
      showEditWindow: true,
      header: `${user.firstName} ${user.lastName}`,
      children: <UserEdit teamMember={user} />,
    }));
  };

  return (
    <>
      <SettingOptions>
        <h1>Help</h1>
        <Section>
          <SectionTitle>
            <h2>Settings</h2>
          </SectionTitle>
          <ButtonsWrapper>
            <LinkChip onClick={showEditWindowHandler}>
              <IonIcon
                icon={person}
                style={{
                  color: "var(--accent-color-dark)",
                }}
              />
              <h4>My Information</h4>
            </LinkChip>
            {user?.PCRoles.some(
              (role) => role.role === "admin" || role.role === "oversight"
            ) && (
              <LinkChip onClick={() => navigate("/help/manage-teams")}>
                <IonIcon
                  icon={people}
                  style={{
                    color: "var(--accent-color-dark)",
                  }}
                />
                <h4>Team Management</h4>
              </LinkChip>
            )}
            {user?.PCRoles.some((role) => role.role === "admin") && (
              <>
                <LinkChip onClick={() => navigate("/help/hot-topics-admin")}>
                  <IonIcon
                    icon={flame}
                    style={{
                      color: "var(--accent-color-dark)",
                    }}
                  />
                  <h4>Hot Topics Admin</h4>
                </LinkChip>
                <LinkChip onClick={() => navigate("/help/data-export")}>
                  <IonIcon
                    icon={download}
                    style={{
                      color: "var(--accent-color-dark)",
                    }}
                  />
                  <h4>Data Export</h4>
                </LinkChip>
              </>
            )}
            {userContext &&
              userContext.currentFirebaseUser?.email ===
                "clement.barbu@hillsong.com" && (
                <>
                  <LinkChip onClick={() => navigate("/help/dataimport")}>
                    <IonIcon
                      icon={documents}
                      style={{
                        color: "var(--accent-color-dark)",
                      }}
                    />
                    <h4>Data Import</h4>
                  </LinkChip>

                  <LinkChip onClick={() => navigate("/help/datacleanup")}>
                    <IonIcon
                      icon={people}
                      style={{
                        color: "var(--accent-color-dark)",
                      }}
                    />
                    <h4>Data Cleanup</h4>
                  </LinkChip>
                </>
              )}
            <LinkChip onClick={() => navigate("/help/notifications")}>
              <IonIcon
                icon={alertCircle}
                style={{
                  color: "var(--accent-color-dark)",
                }}
              />
              <h4>Notifications</h4>
            </LinkChip>
            <LinkChip onClick={SignOutUser}>
              <IonIcon
                icon={logOut}
                style={{
                  color: "var(--accent-color-dark)",
                }}
              />
              <h4>Log Out</h4>
            </LinkChip>
          </ButtonsWrapper>
        </Section>
        <Section>
          <SectionTitle>
            <h2>Infomation</h2>
          </SectionTitle>
          <ButtonsWrapper>
            <LinkChip onClick={() => navigate("/help/cheatsheets")}>
              <IonIcon
                icon={flash}
                style={{
                  color: "var(--accent-color-dark)",
                }}
              />
              <h4>Cheat Sheets</h4>
            </LinkChip>
            <LinkChip
              onClick={() =>
                window.open(
                  "https://hillsongchurch.formstack.com/forms/incident_hazard_report_aus",
                  "_blank"
                )
              }
            >
              <IonIcon
                icon={warning}
                style={{
                  color: "var(--accent-color-dark)",
                }}
              />
              <h4>Incident Report Form</h4>
            </LinkChip>
            <LinkChip
              onClick={() =>
                window.open("https://linktr.ee/pcoversight", "_blank")
              }
            >
              <IonIcon
                icon={link}
                style={{
                  color: "var(--accent-color-dark)",
                }}
              />
              <h4>Linktree</h4>
            </LinkChip>
          </ButtonsWrapper>
        </Section>
        <Section>
          <SectionTitle>
            <h2>Contact</h2>
          </SectionTitle>
          <ButtonsWrapper>
            <LinkChip
              onClick={() =>
                (window.location.href = "mailto:margareta@hillsong.com?")
              }
            >
              <IonIcon
                icon={earth}
                style={{
                  color: "var(--accent-color-dark)",
                }}
              />
              <h4>National Pastoral Care Oversight</h4>
            </LinkChip>
            <LinkChip
              onMouseDown={() =>
                window.open(
                  "https://pastoralcare.blob.core.windows.net/dfvpdfs/NATIONALSERVICESNUMBERS.pdf",
                  "_blank"
                )
              }
            >
              <IonIcon
                icon={call}
                style={{
                  color: "var(--accent-color-dark)",
                }}
              />
              <h4>National & Emergency Hotline Numbers</h4>
            </LinkChip>
          </ButtonsWrapper>
        </Section>
      </SettingOptions>
    </>
  );
}

export default Settings;
